module.exports = __webpack_public_path__ + "static/cstoreslider-03-min-d455eaaf21cba7c837a0fbedb4d47a5c.jpg";